<template>
	<div class="height100dvh mobw-100 notification-main-container">
		<div
			class="jobmob-header mob-back-header d-flex align-items-center justify-content-between"
			id="hideinlaptop"
		>
			<div class="fw-LM fam-lato fs-18 text-black">
				<img
					src="../assets/img/header/bckarw.svg"
					class="mr-2"
					alt=""
					@click="$router.go(-1)"
				/>
				Notifications
			</div>
			<div
				class="text-blue fam-lato fw-B fs-13 underline mr-3"
				v-if="notifications.length !== 0"
				@click="markAllRead"
			>
				Mark all as read
			</div>
		</div>
		<div class="mob-p-3 app-bottom-padding">
			<div class="notifications-dropdown">
				<!-- Header -->
				<div
					id="hideinmobile"
					class="dropdown-header d-flex justify-content-between align-items-center"
				>
					<strong class="fs-16 fam-mont color-344054 fw-M"
						>Notifications</strong
					>
					<div
						v-if="notifications.length !== 0"
						class="fs-12 fam-lato fw-LM text-blue text-underline pointer"
						@click="markAllRead"
					>
						Mark all as read
					</div>
				</div>

				<!-- Notification List -->
				<section
					class="overflow-auto maxheight450px mobh100"
					ref="notiloop"
					@scroll="handleScroll"
				>
					<!-- Empty State -->
					<div
						class="d-flex flex-column align-items-center justify-content-center h-100 my-5"
						v-if="!isLoading && notifications.length === 0"
					>
						<img src="@/assets/img/header/emptynotification.svg" alt="Empty" />
						<h6 class="color-7a7a7a fam-lato fw-M fs-14 mt-2 mb-0">
							You don’t have any notifications
						</h6>
					</div>

					<!-- Loader Skeleton -->
					<div
						v-else-if="isLoading && notifications.length === 0"
						class="px-3 mt-2"
					>
						<b-skeleton
							v-for="i in 5"
							:key="i"
							height="60px"
							width="100%"
							class="mb-3"
						/>
					</div>

					<!-- Notifications by Group -->
					<template v-else>
						<section
							v-for="(groupItems, groupName) in groupedNotifications"
							:key="groupName"
							class="w-100 px-3 my-2"
						>
							<!-- Group Title -->
							<h6 class="fw-M fs-12 fam-lato color-7a7a7a">{{ groupName }}</h6>

							<div
								v-for="(item, index) in groupItems"
								:key="item.notificationID"
								class="w-100"
							>
								<div
									:class="{ unread: !item.read }"
									class="notiitems d-flex w-100 px-2 py-1 justify-content-between mt-1"
								>
									<!-- Message -->
									<div
										v-html="item.message"
										class="w-80 mob-fs-13 fs-14 fw-LM fam-lato color-3a3c40 pointer"
									></div>

									<!-- Right Side Options -->
									<div
										class="fs-10 fw-LM color-7a7a7a font-italic fam-lato d-flex gap5px justify-content-end flex-column align-items-end"
									>
										<div
											class="d-flex align-items-center gap10px position-relative"
											v-closeArray="{
												index,
												property: 'activeDropdownIndex',
												array: groupItems,
												handler: () => closenotiinsideDD(groupName, index),
												exclude: ['notithreedots', 'excludeCard'],
											}"
											ref="excludeCard"
										>
											<img
												src="@/assets/img/header/rightarrow.svg"
												alt="Open"
												class="pointer"
												v-if="item.event && item.event.link"
												@click.stop="openEvent(item.event)"
											/>
											<img
												src="@/assets/img/header/threedots.svg"
												alt="Options"
												class="pointer"
												@click.stop="toggleDropdown(groupName, index)"
												ref="notithreedots"
											/>
											<div
												v-if="item.activeDropdownIndex"
												class="notification-markasread-dd pointer d-flex align-items-center pl-3"
												@click="toggleReadStatus(item)"
											>
												<span
													v-if="item.read"
													class="fs-13 fw-LM color-3a3c40 fam-lato font-normal"
												>
													Mark as unread
												</span>
												<span
													v-else
													class="fs-13 fw-LM color-3a3c40 fam-lato font-normal"
												>
													Mark as read
												</span>
											</div>
										</div>
										<div>
											{{ item.dateTimeText }}
										</div>
									</div>
								</div>
								<hr
									v-if="index !== groupItems.length - 1"
									class="my-2 notification-hr"
								/>
							</div>
						</section>
					</template>

					<!-- Loader Spinner for Infinite Scroll -->
					<div
						style="margin: auto"
						class="d-flex justify-content-center mb-3"
						v-if="showLoader"
					>
						<b-spinner label="Loading..."></b-spinner>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getNotificationData,
	markasReadNotification,
	markasReadandUnreadNotification,
} from "@/utils/apiFunctions";
import toast from "./mixin/toast";
import { mapGetters } from "vuex";
import { Capacitor } from "@capacitor/core";
export default {
	name: "NotificationsDropdown",

	mixins: [toast],
	data() {
		return {
			notifications: [],
			page: 0,
			total: null,
			pageEnd: null,
			showLoader: false,
			isLoading: false,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
			notificationCount: "getNotificationCount",
		}),
		unreadCount() {
			return this.notifications.totalUnreadCount;
		},

		groupedNotifications() {
			const grouped = {};
			this.notifications.forEach((item) => {
				const group = item.daysText || "Others";
				if (!grouped[group]) grouped[group] = [];
				grouped[group].push(item);
			});
			return grouped;
		},
	},

	mounted() {
		// If we already know from the store that there are no notifications,
		// skip the API call and the loader and show the empty state directly.
		if (this.notificationCount === 0) {
			this.notifications = [];
			this.isLoading = false;
			return;
		}
		this.fetchNotifications();
	},
	// watch: {
	// 	notifications: {
	// 		handler(newVal) {
	// 			this.$emit("update-unread-count", newVal.filter((n) => !n.read).length);
	// 		},
	// 		deep: true,
	// 	},
	// },
	methods: {
		async fetchNotifications() {
			try {
				this.isLoading = true;
				const payload = {
					userID: this.userInfo.userID,
					count: 10,
					page: this.page,
					order: -1,
				};
				const res = await getNotificationData(payload);
				if (res.status === 200) {
					this.isLoading = false;
					const newItems = res.data.data.data.map((n) => ({
						...n,
						activeDropdownIndex: false,
					}));
					if (this.page === 0) {
						this.notifications = newItems;
					} else {
						this.notifications = [...this.notifications, ...newItems];
					}
					this.total = res.data.data.totalCount;
					this.pageEnd = res.data.data.pageEnd;
					this.showLoader = false;
				}
			} catch (error) {
				console.error(error);
				this.isLoading = false;
			}
		},
		handleScroll(e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
					target.scrollHeight - target.offsetHeight &&
				this.pageEnd > 0 &&
				this.pageEnd < this.total &&
				!this.showLoader
			) {
				this.showLoader = true;
				this.page++;
				this.fetchNotifications();
			}
		},
		toggleDropdown(groupName, index) {
			const clickedItem = this.groupedNotifications[groupName][index];

			if (clickedItem.activeDropdownIndex) {
				clickedItem.activeDropdownIndex = false;
			} else {
				Object.keys(this.groupedNotifications).forEach((group) => {
					this.groupedNotifications[group].forEach((item) => {
						item.activeDropdownIndex = false;
					});
				});
				clickedItem.activeDropdownIndex = true;
			}
		},
		async toggleReadStatus(item) {
			try {
				const payload = {
					userID: this.userInfo.userID,
					notificationIDs: [item.notificationID],
				};
				const res = await markasReadandUnreadNotification(payload);
				if (res.status === 200) {
					const change = item.read ? 1 : -1;
					item.read = !item.read;
					this.$emit("changeCountvalue", change);
				} else {
					this.errorModal("Something went wrong!");
				}
			} catch (err) {
				this.errorModal("Something went wrong!");
				console.error(err);
			}
		},
		async markAllRead() {
			try {
				const payload = { userID: this.userInfo.userID, markAllRead: true };
				const res = await markasReadNotification(payload);
				if (res.status === 200) {
					this.$nextTick(() => {
						this.successModal(
							"Success",
							"All notifications are marked as read"
						);
					});
					this.$emit("allRead");
					this.fetchNotifications();
				} else {
					this.errorModal("Something went wrong!");
				}
			} catch (err) {
				console.error(err);
				this.errorModal("Something went wrong!");
			}
		},
		 appendQuery(link, query) {
			// let url = new URL(link);
			// url.searchParams.append(query.key, query.value);
			// return url.href;
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append(query.key, query.value);

				return `${baseUrl}#${path}?${params.toString()}`;
			} else {
				const url = new URL(link);
				url.searchParams.append(query.key, query.value);

				return url.href;
			}
		},
		openEvent(event) {
			let finalLink = event.link;
			if (
				finalLink &&
				finalLink.indexOf("https://assessment.hire3x.com/") !== -1 && !Capacitor.isNativePlatform()
			) {
				finalLink = this.appendQuery(finalLink, {
					key: "from",
					value: "candidate",
				});
			}
			if (event.link && event.link.endsWith("/categories")) {
				this.$router.push({
					name: "CandidateAssessmentProgress",
					query: {
						frompage: this.$route.name,
						notif: true,
					},
				});
				this.$emit("closeNotificationDropdown");
			} else if (event.linkType === "2") {
				window.open(finalLink, "_blank");
			} else {
				const url = new URL(event.link, window.location.origin);
				this.$router.push({
					path: url.pathname,
					query: Object.fromEntries(url.searchParams),
				});
				this.$emit("closeNotificationDropdown");
			}
		},
		closenotiinsideDD(groupName, index) {
			this.groupedNotifications[groupName][index].activeDropdownIndex = false;
		},
	},
};
</script>

<style>
.notificationdd .dropdown-header {
	padding: 0.75rem 1rem !important;
	border-bottom: 1px solid #dee2e6;
}
.unread {
	background-color: #e8eff4;
	border-radius: 5px;
}
.unread:hover {
	background: #c8dceb !important;
	border-radius: 5px;
}
.notification-active-class {
	filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
	border-radius: 4px;
}
.notificationdd .dropdown-menu {
	background-color: #ffffff;
	box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
	border-radius: 8px;
	border: unset;
}
.markallread {
	font-family: "Lato";
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	color: #7a7a7a;
}
.notihighlight {
	color: #20639b;
	font-weight: 600;
}
.notiitems:hover {
	background: linear-gradient(0deg, #f6f6f6, #f6f6f6), #e8eff4;
	border-radius: 5px;
}
.notificationdd .dropdown-menu {
	background-color: #ffffff;
	box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
	border-radius: 8px;
	border: unset;
}
.w-10 {
	width: 10% !important;
}
.notificationdd .btn:focus,
.btn.focus {
	box-shadow: unset;
}
.notifications-dropdown {
	width: 435px;
	max-height: 595px;
	overflow-y: auto;
	right: 0;
	top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
	border-radius: 8px;
	position: absolute;
}
.notification-hr {
	border-top: 1px solid #dddddd;
	opacity: unset;
}
.notification-count-tag {
	background: #ad1927;
	border-radius: 100px;
	position: absolute;
	top: -1px;
	width: fit-content;
	padding: 0 5px;
	height: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.notification-markasread-dd {
	width: 189px;
	height: 31px;
	background: #ffffff;
	border-radius: 4px;
	filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4));
	position: absolute;
	right: 0;
	top: 15px;
}
.gap10px {
	gap: 10px;
}
.gap5px {
	gap: 5px;
}
.font-normal {
	font-style: normal;
}
.w-70 {
	width: 70%;
}
.notification-markasread-dd:hover {
	background: #e8eff4;
}
.maxheight450px {
	max-height: 450px;
}
@media (max-width: 1028px) {
	.jobmob-header {
		top: unset !important;
		padding-top: env(safe-area-inset-top) !important;
	}
	.notification-main-container {
		position: relative;
		z-index: 40;
		background-color: #e9ecef;
		/* top: 50px; */
		/* padding: 10px; */
		overflow: hidden;
	}
	.notification-mobile-header {
		height: 44px;
		padding: 10px 16px;
		background: #ffffff;
		box-shadow: 0px 4px 20px #000000;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
	}
	.notifications-dropdown {
		height: calc(
			100dvh - (80px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		width: 100% !important;
		background: #ffffff;
		border-radius: 4px;
		position: unset;
		max-height: unset;
	}
	.mob-p-3 {
		padding: 20px 10px 20px 10px;
	}
	.height100dvh {
		height: 100dvh;
	}
	.mobh100 {
		max-height: 100% !important;
	}
	.notification-count-tag {
		top: -1px !important;
		/* right: -5px !important; */
	}
	.notification-markasread-dd {
		width: 115px;
		color: #344054;
	}
}
</style>
